import {BigDecimal, MoneyResponseBody, UuidResponseBody, VatType} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export type AddRentalPriceGroupItemApiResponse = UuidResponseBody;
export type AddRentalPriceGroupItemApiArg = {
  rentalPriceGroupId: string;
  rentalPriceGroupItemRequestBody: RentalPriceGroupItemRequestBody;
};
export type CreateRentalPriceGroupApiResponse = UuidResponseBody;
export type CreateRentalPriceGroupApiArg = {
  createRentalPriceGroupRequestBody: CreateRentalPriceGroupRequestBody;
};
export type ListRentalPriceGroupApiResponse = RentalPriceGroupListItemResponseBody[];
export type ListRentalPriceGroupApiArg = {};
export type GetRentalPriceGroupApiResponse = RentalPriceGroupResponseBody;
export type GetRentalPriceGroupApiArg = {
  rentalPriceGroupId: string;
};
export type RemoveRentalPriceGroupApiResponse = void;
export type RemoveRentalPriceGroupApiArg = {
  rentalPriceGroupId: string;
};
export type RemoveRentalPriceGroupItemApiResponse = void;
export type RemoveRentalPriceGroupItemApiArg = {
  rentalPriceGroupId: string;
  rentalPriceGroupItemId: string;
};
export type UpdateRentalPriceGroupItemApiResponse = void;
export type UpdateRentalPriceGroupItemApiArg = {
  rentalPriceGroupId: string;
  rentalPriceGroupItemId: string;

  rentalPriceGroupItemRequestBody: RentalPriceGroupItemRequestBody;
};
export type UpdateRentalPriceGroupApiResponse = void;
export type UpdateRentalPriceGroupApiArg = {
  rentalPriceGroupId: string;
  updateRentalPriceGroupRequestBody: UpdateRentalPriceGroupRequestBody;
};
export type ActivateRentalVehicleApiResponse = void;
export type ActivateRentalVehicleApiArg = {
  vehicleId: string;
};
export type DeactivateRentalVehicleApiResponse = void;
export type DeactivateRentalVehicleApiArg = {
  vehicleId: string;
};
export type GetRentalVehicleApiResponse = RentalVehicleResponseBody;
export type GetRentalVehicleApiArg = {
  vehicleId: string;
};
export type PutRentalVehicleApiResponse = UuidResponseBody | UuidResponseBody;
export type PutRentalVehicleApiArg = {
  vehicleId: string;
  rentalVehicleRequestBody: RentalVehicleRequestBody;
};

export type PeriodRangeRequestBody = {
  from: number;
  to: number;
  period: 'day' | 'month';
};
export type PriceRequestBody = {
  rate: BigDecimal;
  ratePerKilometer: BigDecimal;
  includedKilometers: number;
};
export type RentalPriceGroupItemRequestBody = {
  range: PeriodRangeRequestBody;
  price: PriceRequestBody;
  name: string;
};
export type CreateRentalPriceGroupRequestBody = {
  name: string;
  vatType: VatType;
  items: RentalPriceGroupItemRequestBody[];
};
export type RentalPriceGroupListItemResponseBody = {
  rentalPriceGroupId: string;
  name: string;
  vatType: VatType;
};
export type PeriodRangeResponseBody = {
  from: number;
  to: number;
  period: 'day' | 'month';
};
export type PriceResponseBody = {
  rate: string;
  ratePerKilometer: string;
  includedKilometers: number;
};
export type RentalPriceGroupItemResponseBody = {
  rentalPriceGroupItemId: string;
  name: string;
  range: PeriodRangeResponseBody;
  price: PriceResponseBody;
};
export type RentalPriceGroupResponseBody = {
  rentalPriceGroupId: string;
  name: string;
  vatType: VatType;
  items: RentalPriceGroupItemResponseBody[];
};
export type UpdateRentalPriceGroupRequestBody = {
  name: string;
  vatType: VatType;
};
export type AvailabilityResponseBody = {
  from: string | null;
  to: string | null;
  mileageLimit: number | null;
};
export type DefaultRentalPriceGroupResponseBody = {
  rentalPriceGroupId: string;
  rentalPriceGroupItemId: string;
};
export type RentalVehicleOrderResponseBody = {
  rentalOrderId: string;
  branchId: string;
  number: string;
  customerId: string;
  state: string;
  createdAt: string;
  rentalPeriodFrom: string;
  rentalPeriodTo: string;
};
export type RentalVehicleResponseBody = {
  vehicleId: string;
  branchId: string;
  carParkId: string | null;
  vehicleCategoryId: string | null;
  availability: AvailabilityResponseBody;
  note: string | null;
  equipment: string[];
  rentalPriceGroup: DefaultRentalPriceGroupResponseBody | null;
  active: boolean;
  state: 'available' | 'rent' | 'unknown';
  lastRentalOrder: RentalVehicleOrderResponseBody | null;
  upcomingRentalOrder: RentalVehicleOrderResponseBody | null;
};
export type AvailabilityRequestBody = {
  from: string | null;
  to: string | null;
  mileageLimit: number | null;
};
export type DefaultRentalPriceGroupRequestBody = {
  rentalPriceGroupId: string;
  rentalPriceGroupItemId: string;
};
export type RentalVehicleRequestBody = {
  carParkId: string | null;
  vehicleCategoryId?: string | null;
  availability: AvailabilityRequestBody;
  note: string | null;
  equipment: string[];
  rentalPriceGroup: DefaultRentalPriceGroupRequestBody | null;
};
export type ChangeRentalVehicleBranchApiResponse = /** status 204  */ void;
export type ChangeRentalVehicleBranchApiArg = {
  vehicleId: string;
  changeRentalVehicleBranchRequestBody: {
    branchId: string;
  };
};
export type RentalCalendarVehicleResponseBody = {
  vehicleId: string;
  title: string;
  registrationPlate: string | null;
  dailyRate: MoneyResponseBody | null;
  vehicleCategoryId: string | null;
};
export type ListRentalCalendarVehiclesApiResponse = RentalCalendarVehicleResponseBody[];
export type ListRentalCalendarVehiclesApiArg = {
  branchId?: string | null;
  vehicleCategory?: string[];
  carPark?: string[];
  vehicleType?: string[];
  make?: string[];
  modelFamily?: string[];
  bodyStyle?: string[];
  fuelType?: string[];
  transmission?: string[];
  drive?: string[];
  doorCount?: string[];
  seatCount?: string[];
};
export type ListRentalVehicleBlockApiResponse = RentalVehicleBlockListResponseBody;
export type ListRentalVehicleBlockApiArg = {
  vehicleId: string;
};
export type CreateRentalVehicleBlockApiResponse = UuidResponseBody;
export type CreateRentalVehicleBlockApiArg = {
  vehicleId: string;
  createRentalVehicleBlockRequestBody: CreateRentalVehicleBlockRequestBody;
};
export type EditRentalVehicleBlockApiResponse = /** status 204  */ void;
export type EditRentalVehicleBlockApiArg = {
  vehicleId: string;
  blockId: string;
  editRentalVehicleBlockRequestBody: EditRentalVehicleBlockRequestBody;
};
export type DeleteRentalVehicleBlockApiResponse = /** status 204  */ void;
export type DeleteRentalVehicleBlockApiArg = {
  vehicleId: string;
  blockId: string;
};

export type RentalVehicleBlockListItemResponseBody = {
  blockId: string;
  vehicleId: string;
  from: string;
  to: string;
  reasonId: string;
  note: string | null;
};
export type RentalVehicleBlockListResponseBody = {
  blocks: RentalVehicleBlockListItemResponseBody[];
};
export type CreateRentalVehicleBlockRequestBody = {
  from: string;
  to: string;
  reasonId: string;
  note?: string | Nullish;
};
export type EditRentalVehicleBlockRequestBody = {
  from: string;
  to: string;
  reasonId: string;
  note?: string | Nullish;
};
